import { ImagesAssets } from '../constants/ImagesAssets';

export const MockData = {
  infos: [
    {
      id: 1,
      views: 1240,
      title: 'Mobile App Developer',
      bio: 'I build modern, scalable, and beautiful mobile applications using Flutter, clean architecture, APIs, and smooth user experiences.',
      logo: {
        id: 1,
        url: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=500',
        type: 'image'
      },
      cover: {
        id: 2,
        url: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200',
        type: 'image'
      }
    }
  ],

  projects: [
    {
      id: 2,
      numberOfMonths: 3,
      views: 1850,
      title: 'Omaya Class',
      bio: 'An premium e-commerce and delivery platform for a major confectionery chain, enabling customers to order luxury sweets across multiple branches with real-time order tracking and scheduled catering services.',
      logo: { id: 21, url: ImagesAssets.omaya1, type: 'image' },
      cover: { id: 22, url: ImagesAssets.omaya1, type: 'image' },
      media: [
        { id: 23, url: ImagesAssets.omaya1, type: 'image' },
        { id: 24, url: ImagesAssets.omaya2, type: 'image' },
        { id: 25, url: ImagesAssets.omaya3, type: 'image' },
        { id: 26, url: ImagesAssets.omaya4, type: 'image' },
        { id: 27, url: ImagesAssets.omaya5, type: 'image' },
        { id: 28, url: ImagesAssets.omaya6, type: 'image' },
        { id: 29, url: ImagesAssets.omaya7, type: 'image' }
      ],
      projectFeatures: [
        { id: 11, projectId: 2, title: 'Multi-branch geolocation routing' },
        { id: 12, projectId: 2, title: 'Advanced catering & scheduled pre-ordering' },
        { id: 13, projectId: 2, title: 'Live order tracking & delivery status' },
        { id: 14, projectId: 2, title: 'Dynamic loyalty points & rewards wallet' },
        { id: 15, projectId: 2, title: 'Secure integrated payment gateways' },
        { id: 16, projectId: 2, title: 'Real-time stock availability per branch' }
      ],
      projectTools: [
        { id: 1, projectId: 2, title: 'Flutter', media: { id: 101, url: 'flutter_logo_url', type: 'image' } },
        { id: 2, projectId: 2, title: 'Laravel API', media: { id: 102, url: 'laravel_logo_url', type: 'image' } },
        { id: 3, projectId: 2, title: 'Google Maps SDK', media: { id: 103, url: 'maps_logo_url', type: 'image' } },
        { id: 4, projectId: 2, title: 'GetX', media: { id: 104, url: 'getx_logo_url', type: 'image' } },
        { id: 5, projectId: 2, title: 'Firebase Cloud Messaging', media: { id: 105, url: 'fcm_logo_url', type: 'image' } }
      ]
    },
    {
      id: 1,
      numberOfMonths: 4,
      views: 3200,
      title: 'CargoX Delivery App',
      bio: 'A comprehensive logistics and delivery ecosystem featuring real-time driver tracking, automated route optimization, secure OTP verifications, and dynamic order status timelines.',
      logo: { id: 11, url: ImagesAssets.cargo1, type: 'image' },
      cover: { id: 12, url: ImagesAssets.cargo2, type: 'image' },
      media: [
        { id: 13, url: ImagesAssets.cargo3, type: 'image' },
        { id: 14, url: ImagesAssets.cargo4, type: 'image' },
        { id: 15, url: ImagesAssets.cargo5, type: 'image' },
        { id: 16, url: ImagesAssets.cargo6, type: 'image' }
      ],
      projectFeatures: [
        { id: 1, projectId: 1, title: 'Live driver tracking & GPS streaming' },
        { id: 2, projectId: 1, title: 'Secure OTP delivery verification' },
        { id: 3, projectId: 1, title: 'Interactive trip status flow' },
        { id: 4, projectId: 1, title: 'FCM push notifications gateway' },
        { id: 5, projectId: 1, title: 'Digital proof of delivery handling' },
        { id: 6, projectId: 1, title: 'Advanced order status timeline' }
      ],
      projectTools: [
        { id: 1, projectId: 1, title: 'Flutter', media: { id: 101, url: 'flutter_logo_url', type: 'image' } },
        { id: 2, projectId: 1, title: 'Laravel API', media: { id: 102, url: 'laravel_logo_url', type: 'image' } },
        { id: 3, projectId: 1, title: 'Google Maps SDK', media: { id: 103, url: 'maps_logo_url', type: 'image' } },
        { id: 4, projectId: 1, title: 'GetX', media: { id: 104, url: 'getx_logo_url', type: 'image' } },
        { id: 5, projectId: 1, title: 'Firebase Cloud Messaging', media: { id: 105, url: 'fcm_logo_url', type: 'image' } }
      ]
    },
    {
      id: 2,
      numberOfMonths: 3,
      views: 2850,
      title: 'Jaeek Express Delivery',
      bio: 'An on-demand hyper-local delivery solution optimizing multi-stop routing for couriers, instantly calculating ETA, and processing secure cashless transactions via electronic gateways.',
      logo: { id: 21, url: ImagesAssets.jaeek4, type: 'image' },
      cover: { id: 22, url: ImagesAssets.jaeek4, type: 'image' },
      media: [
        { id: 23, url: ImagesAssets.jaeek1, type: 'image' },
        { id: 23, url: ImagesAssets.jaeek2, type: 'image' },
        { id: 23, url: ImagesAssets.jaeek3, type: 'image' },
        { id: 24, url: ImagesAssets.jaeek4, type: 'image' },
        { id: 25, url: ImagesAssets.jaeek5, type: 'image' },
        { id: 26, url: ImagesAssets.jaeek6, type: 'image' },
        { id: 27, url: ImagesAssets.jaeek7, type: 'image' },
        { id: 28, url: ImagesAssets.jaeek8, type: 'image' },
        { id: 29, url: ImagesAssets.jaeek9, type: 'image' },
        { id: 30, url: ImagesAssets.jaeek10, type: 'image' },
        { id: 31, url: ImagesAssets.jaeek11, type: 'image' },
        { id: 32, url: ImagesAssets.jaeek12, type: 'image' },
        { id: 33, url: ImagesAssets.jaeek13, type: 'image' }
      ],
      projectFeatures: [
        { id: 201, projectId: 2, title: 'Hyper-local on-demand delivery dispatch' },
        { id: 202, projectId: 2, title: 'Multi-stop intelligent route optimization' },
        { id: 203, projectId: 2, title: 'Instant distance-based cost calculation' },
        { id: 204, projectId: 2, title: 'In-app real-time customer support chat' },
        { id: 205, projectId: 2, title: 'Secure multi-currency wallet engine' }
      ],
      projectTools: [
        { id: 21, projectId: 2, title: 'Flutter', media: { id: 211, url: 'flutter_logo_url', type: 'image' } },
        { id: 22, projectId: 2, title: 'Node.js Backend', media: { id: 212, url: 'node_logo_url', type: 'image' } },
        { id: 23, projectId: 2, title: 'Socket.io', media: { id: 213, url: 'socket_logo_url', type: 'image' } },
        { id: 24, projectId: 2, title: 'Stripe Gateway', media: { id: 214, url: 'stripe_logo_url', type: 'image' } }
      ]
    },
    {
      id: 3,
      numberOfMonths: 5,
      views: 4100,
      title: 'Moaleme Educational Platform',
      bio: 'An advanced educational hub connecting students and guardians with specialized tutors, offering real-time interactive scheduling, virtual lecture access, and performance monitoring dashboards.',
      logo: { id: 31, url: ImagesAssets.moaleme6, type: 'image' },
      cover: { id: 32, url: ImagesAssets.moaleme6, type: 'image' },
      media: [
        { id: 36, url: ImagesAssets.moaleme6, type: 'image' },
        { id: 34, url: ImagesAssets.moaleme4, type: 'image' },
        { id: 37, url: ImagesAssets.moaleme8, type: 'image' },
        { id: 33, url: ImagesAssets.moaleme1, type: 'image' },
        { id: 33, url: ImagesAssets.moaleme2, type: 'image' },
        { id: 33, url: ImagesAssets.moaleme3, type: 'image' },
        { id: 35, url: ImagesAssets.moaleme5, type: 'image' },
        { id: 37, url: ImagesAssets.moaleme7, type: 'image' },
        { id: 37, url: ImagesAssets.moaleme9, type: 'image' },
        { id: 37, url: ImagesAssets.moaleme10, type: 'image' }
      ],
      projectFeatures: [
        { id: 301, projectId: 3, title: 'Guardian role with multi-child management accounts' },
        { id: 302, projectId: 3, title: 'Dynamic calendar grid booking engine' },
        { id: 303, projectId: 3, title: 'Live lecture access with Agora RTC Integration' },
        { id: 304, projectId: 3, title: 'Automated digital assignments grading loop' },
        { id: 305, projectId: 3, title: 'Comprehensive student progress statistics panels' }
      ],
      projectTools: [
        { id: 31, projectId: 3, title: 'Flutter', media: { id: 311, url: 'flutter_logo_url', type: 'image' } },
        { id: 32, projectId: 3, title: 'Firebase Cloud Functions', media: { id: 312, url: 'firebase_logo_url', type: 'image' } },
        { id: 33, projectId: 3, title: 'Agora SDK', media: { id: 313, url: 'agora_logo_url', type: 'image' } },
        { id: 34, projectId: 3, title: 'Syncfusion Charts', media: { id: 314, url: 'syncfusion_logo_url', type: 'image' } }
      ]
    },
    {
      id: 4,
      numberOfMonths: 6,
      views: 5300,
      title: 'Tabibok Patient App',
      bio: 'A premium telehealth healthcare application facilitating video appointments, automated booking management, prescription tracking, and seamless doctor consultations with background effects.',
      logo: { id: 41, url: ImagesAssets.tabibok7, type: 'image' },
      cover: { id: 42, url: ImagesAssets.tabibok7, type: 'image' },
      media: [
        { id: 43, url: ImagesAssets.tabibok1, type: 'image' },
        { id: 43, url: ImagesAssets.tabibok2, type: 'image' },
        { id: 43, url: ImagesAssets.tabibok3, type: 'image' },
        { id: 44, url: ImagesAssets.tabibok4, type: 'image' },
        { id: 45, url: ImagesAssets.tabibok5, type: 'image' },
        { id: 46, url: ImagesAssets.tabibok6, type: 'image' },
        { id: 47, url: ImagesAssets.tabibok7, type: 'image' },
        { id: 48, url: ImagesAssets.tabibok8, type: 'image' },
        { id: 49, url: ImagesAssets.tabibok9, type: 'image' },
        { id: 50, url: ImagesAssets.tabibok10, type: 'image' },
        { id: 51, url: ImagesAssets.tabibok11, type: 'image' },
        { id: 52, url: ImagesAssets.tabibok12, type: 'image' }
      ],
      projectFeatures: [
        { id: 401, projectId: 4, title: 'High-fidelity video call architecture via Agora Engine' },
        { id: 402, projectId: 4, title: 'Virtual background blur & visual beauty filters toggle' },
        { id: 403, projectId: 4, title: 'Advanced medical clinic search filtering controls' },
        { id: 404, projectId: 4, title: 'Secure electronic health prescription generation' },
        { id: 405, projectId: 4, title: 'Interactive appointment reservation scheduler' }
      ],
      projectTools: [
        { id: 41, projectId: 4, title: 'Flutter', media: { id: 411, url: 'flutter_logo_url', type: 'image' } },
        { id: 42, projectId: 4, title: 'Agora RTC Engine', media: { id: 412, url: 'agora_logo_url', type: 'image' } },
        { id: 43, projectId: 4, title: 'Dio HTTP Client', media: { id: 413, url: 'dio_logo_url', type: 'image' } },
        { id: 44, projectId: 4, title: 'GetX State Management', media: { id: 414, url: 'getx_logo_url', type: 'image' } }
      ]
    },
    {
      id: 5,
      numberOfMonths: 2,
      views: 1950,
      title: 'Taqsiti Installment Management',
      bio: 'A secure financial technology application built to organize micro-loans, calculate customized installment plans, trigger smart payment schedules, and monitor debt recovery status.',
      logo: { id: 51, url: ImagesAssets.taqsiti1, type: 'image' },
      cover: { id: 52, url: ImagesAssets.taqsiti2, type: 'image' },
      media: [
        { id: 53, url: ImagesAssets.taqsiti1, type: 'image' },
        { id: 54, url: ImagesAssets.taqsiti2, type: 'image' }
      ],
      projectFeatures: [
        { id: 501, projectId: 5, title: 'Dynamic monthly installment interest logic calculator' },
        { id: 502, projectId: 5, title: 'Automated system notifications for payment due dates' },
        { id: 503, projectId: 5, title: 'Detailed micro-loan amortization schedule views' },
        { id: 504, projectId: 5, title: 'Electronic payment verification processing logs' }
      ],
      projectTools: [
        { id: 51, projectId: 5, title: 'Flutter', media: { id: 511, url: 'flutter_logo_url', type: 'image' } },
        { id: 52, projectId: 5, title: 'SQLite Storage', media: { id: 512, url: 'sqlite_logo_url', type: 'image' } },
        { id: 53, projectId: 5, title: 'Syncfusion Financial Gauges', media: { id: 513, url: 'syncfusion_logo_url', type: 'image' } }
      ]
    },
    {
      id: 3,
      numberOfMonths: 5,
      views: 2450,
      title: 'Friend Delivery',
      bio: 'A versatile on-demand delivery platform offering seamless product ordering from local retail stores, alongside an advanced parcel courier service supporting multi-stop routing and real-time tracking.',
      logo: { id: 31, url: ImagesAssets.friend1, type: 'image' },
      cover: { id: 32, url: ImagesAssets.friend1, type: 'image' },
      media: [
        { id: 33, url: ImagesAssets.friend1, type: 'image' },
        { id: 34, url: ImagesAssets.friend2, type: 'image' },
        { id: 35, url: ImagesAssets.friend3, type: 'image' },
        { id: 35, url: ImagesAssets.friend4, type: 'image' },
        { id: 35, url: ImagesAssets.friend5, type: 'image' }
      ],
      projectFeatures: [
        { id: 21, projectId: 3, title: 'On-demand local retail store marketplace' },
        { id: 22, projectId: 3, title: 'Multi-stop parcel delivery and smart routing' },
        { id: 23, projectId: 3, title: 'Live location streaming for continuous tracking' },
        { id: 24, projectId: 3, title: 'Dynamic pricing estimation based on distance & stops' },
        { id: 25, projectId: 3, title: 'In-app chat and instant support gateway' },
        { id: 26, projectId: 3, title: 'Multi-step delivery verification (OTP / Signature)' }
      ],
      projectTools: [
        { id: 1, projectId: 3, title: 'Flutter', media: { id: 101, url: 'flutter_logo_url', type: 'image' } },
        { id: 2, projectId: 3, title: 'Laravel API', media: { id: 102, url: 'laravel_logo_url', type: 'image' } },
        { id: 3, projectId: 3, title: 'Google Maps SDK', media: { id: 103, url: 'maps_logo_url', type: 'image' } },
        { id: 4, projectId: 3, title: 'GetX', media: { id: 104, url: 'getx_logo_url', type: 'image' } },
        { id: 5, projectId: 3, title: 'Firebase Cloud Messaging', media: { id: 105, url: 'fcm_logo_url', type: 'image' } }
      ]
    }
  ],

 skills : [
  // --- 1. Architecture & State ---
  { id: 1, title: 'Clean Architecture', media: { id: 33, url: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=500', type: 'image' } },
  { id: 2, title: 'BLoC & Cubit', media: { id: 34, url: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=500', type: 'image' } },
  { id: 3, title: 'Riverpod State', media: { id: 81, url: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=500', type: 'image' } },
  { id: 4, title: 'Functional Dart', media: { id: 82, url: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=500', type: 'image' } },

  // --- 2. Performance & Graphics ---
  { id: 5, title: 'DevTools & Leaks', media: { id: 89, url: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=500', type: 'image' } },
  { id: 6, title: 'Custom RenderObject', media: { id: 39, url: 'https://images.unsplash.com/photo-1504639725590-34d0984388bd?w=500', type: 'image' } },
  { id: 7, title: 'Deep Linking', media: { id: 86, url: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=500', type: 'image' } },
  { id: 8, title: 'Impeller Shaders', media: { id: 87, url: 'https://images.unsplash.com/photo-1558655146-d09347e92766?w=500', type: 'image' } },
  { id: 9, title: 'Tree Shaking', media: { id: 168, url: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=500', type: 'image' } },

  // --- 3. Concurrency & Runtime ---
  { id: 10, title: 'Dart Isolates', media: { id: 167, url: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=500', type: 'image' } },
  { id: 11, title: 'ReactiveX Streams', media: { id: 151, url: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=500', type: 'image' } },
  { id: 12, title: 'GC Tuning', media: { id: 302, url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500', type: 'image' } },
  { id: 13, title: 'Zone Overriding', media: { id: 303, url: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=500', type: 'image' } },

  // --- 4. Shorebird & Code Push ---
  { id: 14, title: 'Shorebird OTA', media: { id: 201, url: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=500', type: 'image' } },
  { id: 15, title: 'Release Flavors', media: { id: 202, url: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=500', type: 'image' } },
  { id: 16, title: 'Patch Rollbacks', media: { id: 203, url: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=500', type: 'image' } },
  { id: 17, title: 'Asset Patching', media: { id: 205, url: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=500', type: 'image' } },
  { id: 18, title: 'AOT Engine Hacking', media: { id: 206, url: 'https://images.unsplash.com/photo-1504639725590-34d0984388bd?w=500', type: 'image' } },

  // --- 5. Hardware & Native ---
  { id: 19, title: 'Platform Channels', media: { id: 164, url: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=500', type: 'image' } },
  { id: 20, title: 'Dart FFI & JNI', media: { id: 161, url: 'https://images.unsplash.com/photo-1579468118864-1b9ea3c0db4a?w=500', type: 'image' } },
  { id: 21, title: 'Headless Tasks', media: { id: 162, url: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=500', type: 'image' } },
  { id: 22, title: 'Native Embedders', media: { id: 305, url: 'https://images.unsplash.com/photo-1566837945700-30057527ade0?w=500', type: 'image' } },

  // --- 6. Security & Reverse Eng ---
  { id: 23, title: 'Root Detection', media: { id: 207, url: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=500', type: 'image' } },
  { id: 24, title: 'R8 Obfuscation', media: { id: 208, url: 'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=500', type: 'image' } },
  { id: 25, title: 'AES-GCM Encryption', media: { id: 209, url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500', type: 'image' } },
  { id: 26, title: 'Secure Enclave', media: { id: 306, url: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=500', type: 'image' } },
  { id: 27, title: 'Frida Defense', media: { id: 307, url: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=500', type: 'image' } },

  // --- 7. Data Systems & Real-Time ---
  { id: 28, title: 'Isar & Hive NoSQL', media: { id: 163, url: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=500', type: 'image' } },
  { id: 29, title: 'CRDT Sync Architecture', media: { id: 159, url: 'https://images.unsplash.com/photo-1621839673705-66b7adc1e825?w=500', type: 'image' } },
  { id: 30, title: 'Binary Caching', media: { id: 191, url: 'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=500', type: 'image' } },
  { id: 31, title: 'gRPC Streams', media: { id: 35, url: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=500', type: 'image' } },
  { id: 32, title: 'WebSockets Auth', media: { id: 152, url: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=500', type: 'image' } },
  { id: 33, title: 'Agora VoIP RTC', media: { id: 153, url: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=500', type: 'image' } },
  { id: 34, title: 'Inertial GIS Tracking', media: { id: 36, url: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=500', type: 'image' } },

  // --- 8. CI/CD & Infra ---
  { id: 35, title: 'Multi-Flavor CI/CD', media: { id: 157, url: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=500', type: 'image' } },
  { id: 36, title: 'Fastlane Match Sync', media: { id: 158, url: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=500', type: 'image' } },
  { id: 37, title: 'Macro Compiler Core', media: { id: 210, url: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=500', type: 'image' } },
  { id: 38, title: 'Engine Compilation', media: { id: 211, url: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=500', type: 'image' } },
  { id: 39, title: 'Melos Monorepo', media: { id: 212, url: 'https://images.unsplash.com/photo-1621839673705-66b7adc1e825?w=500', type: 'image' } },

  // --- 9. Testing & Ecosystem ---
  { id: 40, title: 'E2E Testing Pipelines', media: { id: 85, url: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=500', type: 'image' } },
  { id: 41, title: 'Pub.dev Optimization', media: { id: 156, url: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=500', type: 'image' } },
  { id: 42, title: 'Golden UI Testing', media: { id: 166, url: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=500', type: 'image' } },

  // --- 10. Advanced UI & Micro Runtimes ---
  { id: 43, title: 'Slivers Viewports', media: { id: 84, url: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=500', type: 'image' } },
  { id: 44, title: 'Micro-Frontends', media: { id: 83, url: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=500', type: 'image' } },
  { id: 45, title: 'Vector Canvas Physics', media: { id: 40, url: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=500', type: 'image' } },

  // --- 11. Ultra Low-Level & Hardcore Internals (الإضافات الفائقة الجديدة) ---
  { id: 46, title: 'Dart Kernel Hooking', media: { id: 401, url: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=500', type: 'image' } },
  { id: 47, title: 'Bytecode Manipulation', media: { id: 402, url: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=500', type: 'image' } },
  { id: 48, title: 'Skia/Impeller Hacking', media: { id: 403, url: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=500', type: 'image' } },
  { id: 49, title: 'Native C-Heap Allocation', media: { id: 404, url: 'https://images.unsplash.com/photo-1607799279861-4dd421887fb3?w=500', type: 'image' } },
  { id: 50, title: 'Asynchronous Vsync Sync', media: { id: 405, url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500', type: 'image' } },
  { id: 51, title: 'Low-Level Battery Profiling', media: { id: 406, url: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=500', type: 'image' } }
],

  services: [
    {
      id: 1,
      title: 'Mobile App Service',
      bio: 'Building modern Android and iOS applications using Flutter with clean code, responsive UI, and scalable architecture.',
      media: { id: 41, url: ImagesAssets.rMobile, type: 'image' }
    },
    {
      id: 5,
      title: 'Realtime Features',
      bio: 'Building realtime chat, live tracking, instant notifications, order updates, WebSocket sync, and dynamic experiences.',
      media: { id: 45, url: ImagesAssets.rReal, type: 'image' }
    },
    {
      id: 6,
      title: 'Bug Fixing & Optimization',
      bio: 'Improving app performance, fixing bugs, optimizing code, reducing crashes, and enhancing user experience.',
      media: { id: 46, url: ImagesAssets.rBug, type: 'image' }
    },
    {
      id: 7,
      title: 'Android & iOS Store Publishing',
      bio: 'Preparing app builds, signing releases, testing, writing release notes, and publishing to Google Play and App Store.',
      media: { id: 47, url: ImagesAssets.rStore, type: 'image' }
    },
    {
      id: 8,
      title: 'Electronic Payment Services',
      bio: 'Integrating secure payment gateways, checkout flows, digital wallets, invoices, subscriptions, and transaction tracking.',
      media: { id: 48, url: ImagesAssets.rPay, type: 'image' }
    },
    {
      id: 10,
      title: 'App Maintenance Service',
      bio: 'Maintaining existing apps, updating packages, monitoring performance, improving stability, and fixing production issues.',
      media: { id: 50, url: ImagesAssets.rMain, type: 'image' }
    }
  ],

  contacts: [
    {
      id: 1,
      title: 'WhatsApp',
      link: 'https://wa.me/963997421905',
      media: { id: 46, url: ImagesAssets.whatsapp, type: 'image' }
    },
    {
      id: 3,
      title: 'LinkedIn',
      link: 'https://www.linkedin.com/in/taim-amer-3245a7279?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
      media: { id: 48, url: ImagesAssets.linkedIn, type: 'image' }
    },
    {
      id: 4,
      title: 'GitHub',
      link: 'https://github.com/Taim-Amer',
      media: { id: 49, url: ImagesAssets.github, type: 'image' }
    },
    {
      id: 4,
      title: 'GitLab',
      link: 'https://gitlab.com/taim.amer.000',
      media: { id: 49, url: ImagesAssets.gitlab, type: 'image' }
    },
    {
      id: 5,
      title: 'Email',
      link: 'taim.amer.000@gmail.com',
      media: { id: 50, url: ImagesAssets.google, type: 'image' }
    }
  ]
};
